var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1765 0.494498C9.91631 0.503873 9.66943 0.613248 9.48897 0.800738C7.57335 2.72028 6.11077 4.32334 4.33277 6.13834L2.43901 4.53834C2.23667 4.36724 1.97339 4.28366 1.70855 4.30552C1.44371 4.32817 1.19917 4.45552 1.02809 4.65864C0.856991 4.86254 0.773405 5.12504 0.796845 5.38988C0.820285 5.65472 0.947627 5.89926 1.15153 6.06956L3.75153 8.26956C4.14841 8.60394 4.73435 8.57972 5.10153 8.21331C7.25553 6.05471 8.78913 4.33051 10.9015 2.21331C11.1984 1.92659 11.289 1.48675 11.1281 1.10627C10.9679 0.725028 10.5897 0.482778 10.1765 0.494498Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.826c8b4e38e4f6ed195d13e55be82734.svg";
export { ForwardRef as ReactComponent };